import { useEffect, useRef } from "react";
import { ButtonDef } from "../core/form/ButtonDef";
import { useLocalStorage } from "../core/hooks/useLocalStorage";
import { hasRole } from "../core/hooks/useSession";
import { Breadcrumb } from "../core/ui/Breadcrumb";
import { Notifications } from "../core/ui/Notification";
import { Icon, IconType } from "../core/ui/icons";
import { closest, closestIndex } from "../core/utils/dom";
import { AuthDetails } from "../layout/AuthDetails";
import { api } from "../api/api";
import { WFItem } from "./dashboard/CurrentForms";
import { Table } from "../core/ui/Table";
import { CustomCol } from "../layout/TableCells";
import { SearchBox } from "../core/form/SearchBox";

export function Page(props: {
	title?: {
		text?: string,
		secondary?: any,
		icon?: IconType,
		buttons?: ButtonDef[],
		primaryButton?: any, // top right
		middle?: any,
	}

	padding?: boolean,

	compact?: boolean,

	children?: any,

	onButton?: (btn: ButtonDef) => void,
}) {

	const [account, setAccount] = useLocalStorage<any>("account");
	useEffect(() => {
		if (!account) {
			api.auth_verify_token().then((resp: any) => {
				if (resp.account) {
					setAccount(resp.account);
				}
			}).catch((e) => {

			});
		}
	}, []);

	const refMainMenu = useRef<any>();

	function handleButtonClick(e: any) {
		if (!props.title || !props.title.buttons || !props.onButton) return;

		const i = closestIndex(e.target, ".button");
		if (i < 0) return;
		
		const b = props.title.buttons[i];
		props.onButton(b);
	}

	let title;
	let buttons = [];

	if (props.title) {
		// const icon = props.title.icon ? <Icon type={props.title.icon} /> : undefined;
		//const buttons = [];

		if (props.title.buttons) {
			let i = 0;
			for(let b of props.title.buttons) {
				if (b.role && !hasRole(b.role)) continue;

				buttons.push(
					<button
						data-index={i++}
						key={i}
						className="button primary"
						onClick={handleButtonClick}
					>{b.title}</button>
				);
			}
		}

		title = (
			<div
				className="page-title flex horiz align-center gap-10"
			>
				{/* {icon} */}
				<div className="flex vert align-start fill">
					<div className="flex horiz width-100pc gap-10">
						<div style={{lineHeight: "1"}}>
							<b className="font-large text-brand-secondary">{props.title.text}</b>
							<div className="">{account ? account.name : ""}</div>
						</div>

						{props.title.secondary}

						<div className="page-buttons fill flex horiz gap-5 margin-left-5">
							{props.title.primaryButton}
							{props.title && props.title.middle}
						</div>
					</div>
					{
						!props.compact && <Breadcrumb />
					}
				</div>
			</div>
		);
	}


	function toggleMenu() {
		if (refMainMenu.current) {
			if (refMainMenu.current.style.display !== "flex") {
				refMainMenu.current.style.display = "flex";
			} else {
				refMainMenu.current.style.display = "none";
			}
		}
	}

	if (props.compact) {
		title = 
			<div className="flex horiz gap-10 bg-black text-inverse align-center" style={{padding: "10px 20px"}}>
				{/* <img src="/guardia-logo.svg" style={{width:"100px"}} /> */}
				<a href="/"><Icon type="logo-shield" size="large" style={{fill:"#fff", width: "32px", height: "32px"}} /></a>

				{title}

				<div className="fill text-brand-secondary"></div>

				<Icon
					type="menu"
					className="main-menu"
					onClick={() => {
						toggleMenu();
					}}
				/>

				<div
					className="page-menu flex horiz align-center gap-2"
					ref={refMainMenu}
					onClick={(e) => {
						if (closest(e.target, ".button")) {
							toggleMenu();
						}
					}}
				>
					<button
						className="close-button cancel"
						onClick={(e) => {
							toggleMenu();
							e.stopPropagation();
						}}
					>Close</button>

					<Icon type="logo" style={{fill:"#fff", width: "128px", height: "128px", margin: "0 0 30px 10px"}} className="logo-menu" />

					<div className="actions">
						{buttons}
					</div>

					<SearchBox 
						onSearch={(props) => {
							if (!props.qry) {
								props.setResults(undefined);
								return;
							}

							api.account_search({
								qry: props.qry,
							}).then((results: any) => {
								if (props.cancelled) return;

								props.setResults(
									<GlobalSearchResults results={results} />
								);

							}).catch((e) => {

							});
						}}
					/>

					<AuthDetails />
				</div>

			</div>
	}

	return (
		<div className="page flex horiz align-stretch">

			<Notifications />

			<div className="fill">
				{title}

				<div className="content" style={{
					paddingLeft: ((props.title && props.title.icon) ? "70px" : ""),
					paddingBottom: "80px",
				}}>
					<div className={props.padding !== false ? "padding-10" : ""}>
						{
							props.compact && <div className="margin-bottom-5"><Breadcrumb /></div>
						}

						{props.children}
					</div>
				</div>
			</div>

		</div>

	);
}

export function GlobalSearchResults(props: {
	results: any,
}) {

	const items = [];
	for(let o of props.results.currentOrders) {
		items.push(
			<WFItem awf={o}
				defaultExpanded={true}
				key={"awf" + o.id}
				onChange={() => {}}
				onDelete={(awf) => {}}
				onEdit={(awf) => {}}
				onPay={(awf) => {}}
			/>
			// <div key={o.id}>{o.title}</div>
		)
	}

	if (props.results.entities.length > 0) {
		items.push(
			<Table
				interactive={true}
				cols={[
					CustomCol({
						title: () => "Entity",
						value: (r,c) => {
							let icon;
							if (r.data.type === "individual" || r.data.type === "joint") {
								icon = <Icon type="individual" />
							} else if (r.data.type === "company") {
								icon = <Icon type="company" />
							}

							return (
								<div
									className="flex horiz gap-5"
								>
									{icon}
									{r.title}
								</div>
							);							
						},
					})
				]}
				items={props.results.entities}

				onClick={(e, r) => {
					
				}}
			/>
		)
	}

	return (
		<div className="global-search-results">
			{items}
		</div>
	)
}